import React from 'react'
import withView from '../cmn/docAutomation/withView';
import FormTitle from "../../library/form/components/FormTitle";
import { UiView, UiViewHeading, UiTitle } from "../../library/layout/Index";
import DocItemSelector from './DocItemSelector';

const DocItem = (props)=>{
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)
//acDepCtrl: { 'dparam': '%dataList:valLCat' },
    return(
        <UiView>
        <UiViewHeading>
            <UiTitle>
                <FormTitle formObject={formObject} value='Assign Item' />
            </UiTitle>
        </UiViewHeading>
        <DocItemSelector formObject={formObject} viewData={viewData} />
    </UiView>
    )
}

export default withView(DocItem, "docItem", "docItem,docAttributeValue");
